import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import Tasks from 'APP/Tasks';
import { Avatar, AvatarTypes } from 'APP/components/Avatar/Avatar';
import { WorkspaceProfilePopup } from 'APP/main/PopupManager/Popups/WorkspaceProfilePopup/WorkspaceProfilePopup';
import Entities from 'STORE';

import styles from './SidebarPanelLogo.styles.m.css';

export const SidebarPanelLogo: FC = observer(() => {
  const workspace = Entities.workspace;

  const handleClick = (): void => {
    Tasks.app.openPopup(WorkspaceProfilePopup);
  };

  return (
    <div
      className={styles.logo}
      data-test="logo"
      onClick={handleClick}
    >
      <Avatar
        type={AvatarTypes.Square_10}
        url={workspace.avatarUrl}
        title={workspace.name}
        backgroundColorIndex={workspace.avatarColorIndex}
      />
    </div>
  );
});
